import { render, staticRenderFns } from "./RotacionAsistidaJob.vue?vue&type=template&id=aff16128&scoped=true"
import script from "./RotacionAsistidaJob.vue?vue&type=script&lang=js"
export * from "./RotacionAsistidaJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff16128",
  null
  
)

export default component.exports